import { useIntl } from 'react-intl'

import MemberActivityByDevice from './MemberActivityByDevice'
import messages from './messages'

const DeviceMetricsSection = (props: any) => {
  const intl = useIntl()

  const formatActivityByDevice = (data: any) => {
    const anyCountsGreaterThanZero = data?.desktop > 0 || data?.mobile > 0 || data?.toolbar > 0 || data?.teams > 0
    if (!anyCountsGreaterThanZero) return { byDeviceData: [] }

    const formattedData = [
      {
        name: intl.formatMessage(messages.userActivityDeviceChartLabelDesktop),
        value: data.desktop
      },
      {
        name: intl.formatMessage(messages.userActivityDeviceChartLabelMobile),
        value: data.mobile
      },
      {
        name: intl.formatMessage(messages.userActivityDeviceChartLabelToolbar),
        value: data.toolbar
      },
      {
        name: intl.formatMessage(messages.userActivityDeviceChartLabelTeams),
        value: data.teams
      }
    ]

    return { byDeviceData: formattedData }
  }

  const { byDeviceData } = formatActivityByDevice(props.deviceMetrics)

  return (
    <div className="analytics-section">
      <div className="device-metrics sub-section-wrapper">
        <MemberActivityByDevice byDeviceData={byDeviceData} />
      </div>
    </div>
  )
}

export default DeviceMetricsSection
